import {
  getCreditActions,
  getCreditTierMigrationInfo,
  getCreditTiers,
  getFeatures as creditGetFeatures,
  getOverdueInfo,
  initiateTierMigration,
  migrateTier,
} from '@/api/credit';
import { getFeatures as debtConsolidationGetFeatures } from '@/api/debtConsolidation/debtConsolidation';
import { authenticate, loginBusinessFI, loginUK, loginWithSessionId, syncSessionId } from '@/api/login';
import { getMarketingConsentText, setMarketingConsent } from '@/api/marketingConsent';
import { getBankAccount, getFinancialDetails, getMe, updateFinancialDetails } from '@/api/me/me';
import {
  getMobileVerification,
  sendMobileVerificationCode,
  verifyMobileVerificationCode,
} from '@/api/mobileVerification';
import { getOffers } from '@/api/offers';
import { updatePaybackPlan } from '@/api/paybackPlan';
import {
  completeLoan,
  getPendingTransaction,
  getWithdrawalById,
  payExtra,
  payOverdue,
  withdraw,
  withdrawFullAmount,
} from '@/api/paymentProvider';
import { getPromotions } from '@/api/promotions';
import SE from '@/api/SE';
import {
  createBusinessUser,
  generateAuthTokenWithNationalNumber,
  getEmbeddedPartners,
  getProductTiers,
} from '@/api/simulate';
import UK from '@/api/UK';
import {
  activateCampaign,
  activatePaymentProtectionInsurance,
  activateUserIdProtect,
  declineCampaign,
  getCampaign,
  getUserIdProtect,
  getUserPaymentProtectionInsurance,
  getUserTerminateAccountDetails,
  getUserTransactions,
  markCampaignAsViewed,
  sendEmailVerificationCode,
  sendMobileVerificationCode as sendSEMobileVerificationCode,
  terminateAccount,
  terminatePaymentProtectionInsurance,
  terminateUserIdProtect,
  updateEmail,
  updateMobile,
  updateUserDetails,
  verifyEmailVerificationCode,
} from '@/api/user';
import { acknowledgeTermsAndConditions, getUsersMe } from '@/api/users';

const API = {
  SE,
  UK,
  login: { authenticate, loginBusinessFI, loginUK, loginWithSessionId, syncSessionId },
  credit: {
    getCreditActions,
    getCreditTierMigrationInfo,
    getCreditTiers,
    getFeatures: creditGetFeatures,
    getOverdueInfo,
    initiateTierMigration,
    migrateTier,
  },
  paymentProvider: {
    completeLoan,
    getPendingTransaction,
    getWithdrawalById,
    payExtra,
    payOverdue,
    withdraw,
    withdrawFullAmount,
  },
  user: {
    activateCampaign,
    activatePaymentProtectionInsurance,
    activateUserIdProtect,
    declineCampaign,
    getCampaign,
    getUserIdProtect,
    getUserPaymentProtectionInsurance,
    getUserTerminateAccountDetails,
    getUserTransactions,
    markCampaignAsViewed,
    sendEmailVerificationCode,
    sendMobileVerificationCode: sendSEMobileVerificationCode,
    verifyEmailVerificationCode,
    terminateAccount,
    terminatePaymentProtectionInsurance,
    terminateUserIdProtect,
    updateEmail,
    updateMobile,
    updateUserDetails,
  },
  users: { acknowledgeTermsAndConditions, getUsersMe },
  simulate: { createBusinessUser, generateAuthTokenWithNationalNumber, getProductTiers, getEmbeddedPartners },
  marketingConsent: { getMarketingConsentText, setMarketingConsent },
  me: { getBankAccount, getFinancialDetails, getMe, updateFinancialDetails },
  mobileVerification: { getMobileVerification, sendMobileVerificationCode, verifyMobileVerificationCode },
  debtConsolidation: { getFeatures: debtConsolidationGetFeatures },
  paybackPlan: { updatePaybackPlan },
  offers: { getOffers },
  promotions: { getPromotions },
};

export default API;
export * from '@/api/credit/types';
export * from '@/api/debtConsolidation/types';
export * from '@/api/marketingConsent/types';
export * from '@/api/me/types';
export * from '@/api/mobileVerification/types';
export * from '@/api/paybackPlan/types';
export * from '@/api/paymentProvider/types';
export * from '@/api/promotions/types';
export * from '@/api/SE/applicants/types';
export * from '@/api/SE/bankId/types';
export * from '@/api/UK/applicants/types';
export * from '@/api/user/types';
